import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ManagementService {
  private apiAreaUrl = `${environment.apiUrl}/area`;
  private apiJobPositionUrl = `${environment.apiUrl}/jobpositions`;
  private apiCountryUrl = `${environment.apiUrl}/countries`;
  private apiCityUrl = `${environment.apiUrl}/cities`;

  constructor(private http: HttpClient) {}

  // Areas
  createArea(data: FormData): Observable<any> {
    return this.http.post<any>(this.apiAreaUrl + '/register', data);
  }

  postListAreas(filter: { search: string }): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiAreaUrl + '/listAllAreasWithJob',
      filter
    );
  }

  getAreaByAreaId(areaId: number): Observable<any> {
    return this.http.get<any>(`${this.apiAreaUrl}/${areaId}`);
  }

  updateArea(data: FormData, areaId: number): Observable<any> {
    return this.http.put<any>(`${this.apiAreaUrl}/update/${areaId}`, data);
  }

  // Cargos
  createJobPosition(data: FormData, areaId: number): Observable<any> {
    return this.http.post<any>(
      `${this.apiJobPositionUrl}/register/${areaId}`,
      data
    );
  }

  getJobPositionDetailByJobPositionId(jobPositionId: number): Observable<any> {
    return this.http.get<any>(`${this.apiJobPositionUrl}/${jobPositionId}`);
  }

  updateJobPosition(data: FormData, jobPositionId: number): Observable<any> {
    return this.http.put<any>(
      `${this.apiJobPositionUrl}/update/${jobPositionId}`,
      data
    );
  }

  // Paises
  createCountry(data: FormData): Observable<any> {
    return this.http.post<any>(this.apiCountryUrl + '/register', data);
  }

  postListCountries(filter: { search: string }): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiCountryUrl + '/listAllCountriesWithCity',
      filter
    );
  }

  updateCountry(data: FormData, countryId: number): Observable<any> {
    return this.http.put<any>(
      `${this.apiCountryUrl}/update/${countryId}`,
      data
    );
  }

  // Ciudades
  createCity(data: FormData, countryId: number): Observable<any> {
    return this.http.post<any>(
      `${this.apiCityUrl}/register/${countryId}`,
      data
    );
  }

  getCityByCityId(cityId: number): Observable<any> {
    return this.http.get<any>(`${this.apiCityUrl}/${cityId}`);
  }

  updateCity(data: FormData, cityId: number): Observable<any> {
    return this.http.put<any>(`${this.apiCityUrl}/update/${cityId}`, data);
  }
}
